export default __webpack_public_path__ + "f980bc4c8656e86fb68aee0ffc6d6a34.jpg";